import { useParams } from 'react-router-dom';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { Employee } from 'src/types/Employee';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { useGetEmployee } from 'src/components/enterprise/features/Employee/EditPage/hooks/useGetEmployee';
import { useUpdateEmployee } from 'src/components/enterprise/features/Employee/EditPage/hooks/useUpdateEmployee';

type UseEmployeeDetailsReturnType = {
  employeeData: Employee;
  employeeFormValues?: EmployeeFormFields;
  getEmployeeLoading: boolean;
  updateEmployee: (values: EmployeeFormFields) => Promise<void>;
  hasGetEmployeeError: boolean;
};

export type UseEmployeeEditPageProps = {
  onSuccess?: (employee: Employee) => Promise<void>;
  onError?: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export function useEmployeeEditPage({
  onSuccess,
  onError,
}: UseEmployeeEditPageProps): UseEmployeeDetailsReturnType {
  const { corpid: corpId, employeeId } =
    useParams<{ corpid: string; employeeId: string }>();

  const {
    employeeData,
    employeeFormValues,
    isLoading: getEmployeeLoading,
    hasError: hasGetEmployeeError,
  } = useGetEmployee(corpId, employeeId);

  const { updateEmployee } = useUpdateEmployee({
    corpId,
    employeeId,
    employeeRawData: employeeData,
    onSuccess,
    onError,
  });

  return {
    employeeData,
    employeeFormValues,
    getEmployeeLoading,
    hasGetEmployeeError,
    updateEmployee,
  };
}
